(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/pullAll', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/pullAll'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.pullAll, global.convert);
    global.pullAll = mod.exports;
  }
})(this, function (exports, _pullAll2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.pullAll = undefined;

  var _pullAll3 = _interopRequireDefault(_pullAll2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * This method is like {@link array.pull} except that it accepts an array of values to remove.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {Array} values The values to remove.
   * @return {Object} Returns the updated object.
   * @example pullAll({ nested: { prop: [1, 2, 3, 1, 2, 3] } }, 'nested.prop', [1, 3]) // => { nested: { prop: [2, 2] } }
   * @see {@link https://lodash.com/docs#pullAll|lodash.pullAll} for more information.
   * @since 0.3.0
   */
  var pullAll = (0, _convert.convert)(_pullAll3.default);
  exports.pullAll = pullAll;
  exports.default = pullAll;
});